"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Ready() {
  const reduce = useReducedMotion();
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : 0.11,
        delayChildren: 0.05
      }
    }
  };
  const item = reduce ? {
    hidden: {
      opacity: 1,
      y: 0
    },
    show: {
      opacity: 1,
      y: 0
    }
  } : {
    hidden: {
      opacity: 0,
      y: 18
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.72,
        ease: [0.2, 0.7, 0.2, 1]
      }
    }
  };
  return <section data-section-id="32900" id="soluciones-inmediatas-vía-whatsapp" data-nav="dark" className="dark bg-background text-foreground relative overflow-hidden py-28 md:py-40" style={{
    backgroundColor: "hsl(217 62% 9%)",
    color: "hsl(36 30% 96%)"
  }}>
      {}
      <svg aria-hidden="true" viewBox="0 0 1400 400" preserveAspectRatio="xMinYMax slice" className="pointer-events-none absolute -left-24 bottom-0 h-[55%] w-[130%] md:h-[70%] md:w-[110%]" style={{
      opacity: 0.06
    }}>
        <path d="M-100,400 L-100,320 L60,240 L140,290 L240,180 L340,250 L440,140 L540,220 L640,90 L740,200 L840,120 L960,230 L1080,150 L1200,260 L1320,180 L1440,240 L1500,400 Z" fill="hsl(36 30% 96%)" />
      </svg>

      <div className="relative mx-auto max-w-[72ch] px-6 md:px-10 lg:px-16">
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-col items-start text-left">
          {}
          <motion.div variants={item} className="flex items-center gap-3" style={{
          color: "hsl(18 78% 48%)"
        }}>
            <span aria-hidden="true" className="inline-block h-3 w-px" style={{
            backgroundColor: "hsl(18 78% 48%)"
          }} />
            <span className="font-sans text-xs font-semibold uppercase md:text-[0.8125rem]" style={{
            letterSpacing: "0.18em",
            lineHeight: 1.1
          }}>
              Urgencias 24 horas
            </span>
            <span aria-hidden="true" className="inline-block h-3 w-px" style={{
            backgroundColor: "hsl(18 78% 48%)"
          }} />
          </motion.div>

          {}
          <motion.h2 variants={item} className="font-mono mt-5 uppercase font-bold" style={{
          fontSize: "clamp(2.5rem, 6vw, 5.25rem)",
          lineHeight: 0.95,
          letterSpacing: "-0.005em",
          color: "hsl(36 30% 96%)"
        }}>
            ¿Tiene una avería? Escríbanos y le atendemos hoy mismo.
          </motion.h2>

          {}
          <motion.p variants={item} className="font-sans mt-7 max-w-[62ch]" style={{
          fontSize: "clamp(1.0625rem, 1.35vw, 1.25rem)",
          lineHeight: 1.55,
          color: "hsl(215 20% 75%)"
        }}>
            Fontanería, climatización, fugas, piscinas y reformas en Totana, Murcia, Alicante y Almería. Respuesta rápida y presupuesto sin compromiso.
          </motion.p>

          {}
          <motion.div variants={item} className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
            <Button asChild className="h-auto rounded-lg px-8 py-4 text-sm font-semibold uppercase border-0 w-full sm:w-auto" style={{
            backgroundColor: "#25D366",
            color: "#ffffff",
            letterSpacing: "0.02em"
          }}>
              <Link to="https://wa.me/34657068444" newTab>
                Escríbenos por WhatsApp
              </Link>
            </Button>

            <Button asChild variant="outline" className="h-auto rounded-lg px-7 py-3.5 text-sm font-semibold uppercase w-full sm:w-auto" style={{
            backgroundColor: "transparent",
            borderColor: "hsl(36 30% 96%)",
            borderWidth: "1px",
            color: "hsl(36 30% 96%)",
            letterSpacing: "0.02em"
          }}>
              <Link to="tel:+34657068444">Llamar al +34 657 068 444</Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}